import { restClient } from '../config/restClient'

const endpoint = interviewRequestId => `/api/company/v2/interview_requests/${interviewRequestId}/event_feedbacks`

export const getInterviewRequestEventFeedbacks = async (interviewRequestId, params) => {
  const response = await restClient(endpoint(interviewRequestId), {
    method: 'GET',
    params,
  })
  return response.data
}

export const postInterviewRequestEventFeedback = async (interviewRequestId, data) => {
  const response = await restClient(endpoint(interviewRequestId), {
    method: 'POST',
    data,
  })
  return response.data
}
